'use strict';

var React = require('react');
var reactUtils = require('@sravni/react-utils');

function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

/** Dialog or Sheet counter */
let openModalsCount = 0;
/** Window history offset */
let historyOffset = 0;
/**
 * React hook executes closeHandler on back browser button click (or software simulation), especially useful in the Sheet and Dialog on mobile devices
 *
 * @param enable enabling of the hook
 * @param visible current state of the modal
 * @param closeHandler handler to be executed when the modal closes
 * @returns closeEventHandler
 * @example
 * ```javascript
 * const { closeEventHandler } = useBackwardEvent(closeOnBackward, !!visible, handleClose)
 * ```
 */
function useBackwardEvent(enable, visible, closeHandler) {
    const modalIndex = React__namespace.useRef(0);
    const handleCloseOnBackward = React__namespace.useCallback((event) => {
        if (modalIndex.current === openModalsCount - 1) {
            closeHandler?.(event);
            historyOffset -= 1;
        }
    }, [closeHandler]);
    const openEventHandler = () => {
        window.history.pushState({ ...window.history.state }, '');
        historyOffset += 1;
        openModalsCount += 1;
    };
    const closeEventHandler = () => {
        openModalsCount = openModalsCount > 1 ? openModalsCount - 1 : 0;
        if (openModalsCount === 0) {
            historyOffset && window.history.go(0 - historyOffset);
            historyOffset = 0;
        }
    };
    React__namespace.useEffect(() => {
        if (!reactUtils.isBrowser || !enable)
            return;
        if (visible) {
            modalIndex.current = openModalsCount;
            openEventHandler();
            window.addEventListener('popstate', handleCloseOnBackward);
        }
        else {
            window.removeEventListener('popstate', handleCloseOnBackward);
        }
        return () => window.removeEventListener('popstate', handleCloseOnBackward);
    }, [enable, handleCloseOnBackward, visible]);
    if (!reactUtils.isBrowser || !enable)
        return { closeEventHandler: reactUtils.noop };
    return {
        closeEventHandler,
    };
}

exports.useBackwardEvent = useBackwardEvent;
//# sourceMappingURL=useBackwardEvent.js.map
